<template>
  <ap3-access-gate>
    <router-view />
  </ap3-access-gate>
</template>

<script>
import { mapState } from 'vuex';
import ap3AccessGate from '@/components/ap3AccessGate';

export default {
  components: { ap3AccessGate },
  computed: {
    ...mapState('sites', ['multigroups']),
    activeMultigroup() {
      return this.multigroups.find((e) => e.id === this.$route.params.app);
    },
  },
  mounted() {
    if (this.activeMultigroup) {
      this.$store.commit('adminPanel/setViewTitle', {
        depth: 0,
        title: `${this.activeMultigroup.name} Sites`,
        to: { name: 'sites-listing', params: { app: this.activeMultigroup.id } },
        last: false,
      });
    } else {
      this.$store.commit('adminPanel/setViewTitle', {
        depth: 0,
        title: 'All Sites',
        to: { name: 'sites-listing', params: { app: 'all' } },
        last: false,
      });
    }
  },
};
</script>

<style></style>
